import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/auth';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // OAuth2 콜백 후 사용자 정보 확인
        await authApi.getCurrentUser();
        // 성공하면 대시보드로 리다이렉트
        navigate('/dashboard', { replace: true });
      } catch (error) {
        console.error('Authentication failed:', error);
        // 실패하면 로그인 페이지로
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#FF7A7A] mx-auto mb-4"></div>
        <p className="text-gray-600 text-lg">인증 처리 중...</p>
      </div>
    </div>
  );
}
